import React, {FormEvent, useContext, useState, JSX, useEffect} from 'react';
import { WorkflowContext } from "../../context/WorkflowContextProvider";
import Form from '@rjsf/mui';
import { IChangeEvent } from '@rjsf/core';
import {RegistryWidgetsType, RJSFSchema, UiSchema} from '@rjsf/utils';
import validator from '@rjsf/validator-ajv8';
import { DefaultFormDialog  } from "./components/DefaultFormDialog";
import { useReactFlow, applyNodeChanges, Node, ReactFlowInstance } from "@xyflow/react";
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import { processNodeDelete, processNodeFormSubmit, formSchema, nodeDescription } from "./functions/workflow-ui-update-configuration";
import {
    Button
} from '@mui/material';

export const WorkflowUiUpdateConfiguration: () => JSX.Element = (): JSX.Element => {
    const context: any = useContext(WorkflowContext);
    const reactFlowInstance: ReactFlowInstance = useReactFlow();
    const [formData, setFormData] = useState<any>();

    function handleCloseDialog(): void {
        context.toggleActiveEditUiUpdateModal(false);
    }

    const handleFormSubmit: (data: IChangeEvent, event: FormEvent<any>) => void = (data: IChangeEvent, event: FormEvent<any>) : void => {
        processNodeFormSubmit(context, data.formData, reactFlowInstance);
        handleCloseDialog();
    }

    function deleteNode(): void {
        processNodeDelete(context, reactFlowInstance);
        handleCloseDialog();
    }

    const uiSchema: UiSchema = {
        'message': {
            'ui:widget': 'textarea'
        }

    }

    useEffect( (): void => {
        if (context.activeEditUiUpdateNode !== undefined && context.activeEditUiUpdateNode.data !== undefined) {
            setFormData(context.activeEditUiUpdateNode.data);
        }
    } , [context] );


    return (
        <DefaultFormDialog
            open={ context.showUiUpdateModal }
            title={ "Ui Message Node Configuration" }
            handleClose={ handleCloseDialog }
            description={ nodeDescription }
        >
            <Form
                validator={validator}
                schema={ formSchema }
                uiSchema={ uiSchema }
                onSubmit={ handleFormSubmit }
                formData={ formData }
                formContext={ formData }
                onChange={({ formData }: IChangeEvent): void => setFormData(formData)}
            >
                <div className="dialog__actions form-group">
                    <Button type="submit"
                            variant="contained"
                            color="success"
                    >
                        <SaveIcon />
                        <span>{ "Save" }</span>
                    </Button>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={ deleteNode }
                        type="button">
                        <DeleteIcon />
                        <span>{ "Delete" }</span>
                    </Button>

                </div>
            </Form>

        </DefaultFormDialog>
    );
}